import { Component, OnInit, inject } from '@angular/core';
import {DataService} from "../../../services/data.service";
import {RouterLink} from "@angular/router";
import {NgForOf, NgIf} from "@angular/common";

@Component({
    selector: 'app-tasktype-list',
    templateUrl: './tasktype-list.component.html',
    imports: [
        RouterLink,
        NgIf,
        NgForOf
    ],
    styleUrl: './tasktype-list.component.scss'
})
export class TasktypeListComponent implements OnInit {

    private dataService = inject(DataService);

    paginConfig;
    entries;
    totalEntries;
    predicate;
    search;
    reverse;

    ngOnInit(): void {
        this.search = {
            text: ''
        };
        this.paginConfig = {
            itemsPerPage: 25,
            page: 1
        };
        this.reverse = false;
        this.totalEntries = 0;
        this.predicate = 'name';
        this.listEntries(this.paginConfig);
    }

    setOrder(order): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    checkFilterAndList(): void {
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event): void {
        this.paginConfig = event;

        this.entries = null;
        this.dataService.request('Tasktype/listAll', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate,
            reverse: this.reverse,
            filter: this.search.text,
        }).subscribe(response => {
            this.totalEntries = response.total;
            this.entries = response.tasktypes;
        });
    }

}
